import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import TopActions from './TopActions';
import { columns } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const Component = ({
  theme,
  fuelConsumption,
  filterSuccess,
  Styled,
  i18n,
  topAction,
  filters,
  pagination,
  setPagination,
  vehicleList,
  driverList,
  getVehicleListDropDown,
  getDrivers,
  getStateListData,
  addEditFuelData,
  callback,
}) => {
  const generateRows = () => {
    const updatedList = fuelConsumption?.filteredList?.map((item) => {
      let result = { ...item };
      let jurisdictionLocation = ``;
      if (item.jurisdiction == 'Unknown' || !item.jurisdiction) jurisdictionLocation = item.location;
      if (item.jurisdiction == 'Unknown') item.jurisdiction = i18n.t('fuelConsumption.unknown');
      else jurisdictionLocation = `${item.jurisdiction} - ${item.location}`;
      result.jurisdictionLocation = checkServiceProvider(
        'generateRows_jurisdictionLocation',
        window.$environment?.SERVICE_PROVIDER,
        false
      )
        ? jurisdictionLocation
        : item.jurisdiction;
      result.vehicleName = (
        <a className="showDoc" href={`/vehicle/edit/${item.vehicle?.id}`} rel="noopener noreferrer" target="_blank">
          {item.vehicleName}
        </a>
      );
      result.history = (
        <a className="showDoc" href={`/fuel/history/${item.vehicle?.id}`} rel="noopener noreferrer" target="_blank">
          {i18n.t('View History')}
        </a>
      );
      return result;
    });
    return updatedList;
  };

  const information = i18n.t('common.tableEmptyMessage');
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              Styled,
              fuelConsumption,
              i18n,
              filterSuccess,
              filters,
              setPagination,
              vehicleList,
              driverList,
              getVehicleListDropDown,
              getDrivers,
              getStateListData,
              addEditFuelData,
              callback,
            }}
          />
        )}
        <Styled.TableWrapper>
          <div className="quickFilter"></div>
          <Table
            type="client"
            title=""
            columns={columns}
            data={generateRows()}
            emptyMessage={information}
            actions={[]}
            defaultSortBy={{ sortBy: 'vehicleName', order: 'asc' }}
            itemsPerPage={15}
            i18n={i18n}
            className="fuelConsumption"
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </Box>
  );
};

Component.propTypes = {
  filterSuccess: PropTypes.func.isRequired,
};

export default Component;
